var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "alarm_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#alarm_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 12.6V9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 9v3.975q0 .2.075.387.075.188.225.338l2.8 2.8a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7zM12 22q-1.874 0-3.513-.713a9.2 9.2 0 0 1-2.85-1.925 9.2 9.2 0 0 1-1.925-2.85A8.7 8.7 0 0 1 3 13q0-1.874.712-3.513a9.2 9.2 0 0 1 1.925-2.85 9.2 9.2 0 0 1 2.85-1.925A8.7 8.7 0 0 1 12 4q1.874 0 3.512.712a9.2 9.2 0 0 1 2.85 1.925 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 13q0 1.875-.712 3.512a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.925A8.7 8.7 0 0 1 12 22M2.05 7.3a.95.95 0 0 1-.275-.7q0-.425.275-.7L4.9 3.05a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L3.45 7.3a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275m19.9 0a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275L17.7 4.45a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l2.85 2.85a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7M12 20q2.925 0 4.962-2.038T19 13t-2.038-4.963T12 6 7.037 8.037 5 13t2.037 4.962T12 20"
  }))));
};
export default SvgAlarm;